import * as types from 'store/actions/types';

// Import types
import type { AppDispatch } from 'store/store';
import { PacketSubtype } from 'types/api/products/product';

// Import helpers
import { fetchPacketList } from 'helpers/api/products';

export const fetchPackets = async (dispatch: AppDispatch) => {
	try {
		// Dispatch an loading action
		dispatch({
			type: types.FETCH_PACKETS_LOADING,
			payload: true
		});

		const data = await fetchPacketList({ subtype: [PacketSubtype.Main], order: 'order', orderDir: 'asc' });

		// Dispatch an success action
		dispatch({
			type: types.FETCH_PACKETS_SUCCESS,
			payload: data
		});
	} catch {
		// Dispatch an error action
		dispatch({
			type: types.FETCH_PACKETS_ERROR,
			payload: true
		});
	}
};
